import store from "../../redux/store";
import axios from "axios";
const BackendApiBaseUrl = process.env.REACT_APP_API_URL;

export const getImage = async (s3key) => {
  if (s3key) {
    const token = store.getState().authReducer.user.authToken;
    const headers = { "Content-Type": "application/json", Authorization: token };
    const response = await axios.post(
      `${BackendApiBaseUrl}/upload/get`,
      {
        s3key: s3key,
      },
      { headers }
    );
    return response.data;
  }
};

export const downloadAttachments = async (s3Key) => {
  var response = ''
  if (s3Key) {
    const token = store.getState().authReducer.user.authToken;
    const headers = { "Content-Type": "application/json", Authorization: token };
    const results = await axios.get(
      `${BackendApiBaseUrl}/message/getattachment/${s3Key}`,
      { headers }
    ).then(result => {
      response = result.data.downloadURL;
    })
    return response
  }
}
